import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentCartStoreService } from '@common/services';
import { RoutesResRoutes } from '@conf/routes.config';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-payment-input-test',
  templateUrl: './payment-input-test.component.html',
  styleUrls: ['../../test-ssn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentInputTestComponent extends SupportComponent {
  reload(): void {}
  init(): void {}
  destroy(): void {}
  constructor(
    private _common: CommonLibService,
    private _router: Router,
    private _currentCartService: CurrentCartStoreService
  ) {
    super(_common);
  }

  paymentInputTest1() {
    this._currentCartService.updateCurrentCart({ data: { cartId: '111222' } });
    this._router.navigateByUrl(RoutesResRoutes.PAYMENT_INPUT);
  }
}
